import { z } from 'zod';
import * as FlatModels from '../../internal';

export const Severity = z.enum([
  'danger',
  'error',
  'warning',
  'success',
  'info',
]);
export type Severity = z.infer<typeof Severity>;

export const SeverityIcon: Record<string, string> = {
  [Severity.enum.danger]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ERROR,
  [Severity.enum.error]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ERROR,
  [Severity.enum.warning]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.WARNING,
  [Severity.enum.success]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.INFO,
  [Severity.enum.info]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.INFO,
}